export const ACTION_SET_XCARD = 'ACTION_SET_XCARD';

export const ACTION_LOAD_XCARD_INIT__REQUEST = 'ACTION_LOAD_XCARD_INIT__REQUEST';
export const ACTION_LOAD_XCARD_INIT__SUCCESS = 'ACTION_LOAD_XCARD_INIT__SUCCESS';
export const ACTION_LOAD_XCARD_INIT__FAIL = 'ACTION_LOAD_XCARD_INIT__FAIL';

export const ACTION_ORDER_XCARD__REQUEST = 'ACTION_ORDER_XCARD__REQUEST';
export const ACTION_ORDER_XCARD__SUCCESS = 'ACTION_ORDER_XCARD__SUCCESS';
export const ACTION_ORDER_XCARD__FAIL = 'ACTION_ORDER_XCARD__FAIL';

export const ACTION_RECHECK_XCARD_STATUS__REQUEST = 'ACTION_RECHECK_XCARD_STATUS__REQUEST';
export const ACTION_RECHECK_XCARD_STATUS__SUCCESS = 'ACTION_RECHECK_XCARD_STATUS__SUCCESS';
export const ACTION_RECHECK_XCARD_STATUS__FAIL = 'ACTION_RECHECK_XCARD_STATUS__FAIL';
